/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlManagedClientIDsResponse
 */
export interface ControlManagedClientIDsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlManagedClientIDsResponse
     */
    client_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlManagedClientIDsResponse interface.
 */
export function instanceOfControlManagedClientIDsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_ids" in value;

    return isInstance;
}

export function ControlManagedClientIDsResponseFromJSON(json: any): ControlManagedClientIDsResponse {
    return ControlManagedClientIDsResponseFromJSONTyped(json, false);
}

export function ControlManagedClientIDsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlManagedClientIDsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_ids': json['client_ids'],
    };
}

export function ControlManagedClientIDsResponseToJSON(value?: ControlManagedClientIDsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_ids': value.client_ids,
    };
}

